import '@babel/polyfill'
import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
// import GoogleAuth from 'vue-google-oauth'
import GoogleAuth from 'vue-google-authenticator'
import './registerServiceWorker'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import 'paymentfont/css/paymentfont.min.css'

Vue.use(GoogleAuth, {
  client_id: '450656536006-oo9eijqb96gilmafd3incd5a2t8hqjbn.apps.googleusercontent.com'
})
Vue.googleAuth().load();

let location = window.location.href,
  host = 'https://web-test.purepurr.tech';

if (location.startsWith('https://web.purepurr.tech')) {
  host = 'https://web.purepurr.tech';
}

Vue.prototype.$hostname = host + '/api'; //web.purepurr.tech
Vue.prototype.$googleLink = host; //web.purepurr.tech
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')